import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

// import Tabs from './Tabs'
// import Pane from './Tab'

// import EUVerifyContainer from '../containers/EUVerifyContainer'
// import UKVerifyContainer from '../containers/UKVerifyContainer'

import CreateContainer from '../containers/CreateContainer'
import VerifyContainer from '../containers/VerifyContainer'

import ErrorPopup from './ErrorPopup'

class Body extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
    		selected: 0
    	}

    	this.switchTab = this.switchTab.bind(this);
	}

	switchTab (e) {
		var num = parseInt(e.target.value, 10)
		this.setState({"selected": num})
	}

	render() {
		return (
			<div>
				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{textAlign: "center"}}>
					<label className="col-lg-5 col-md-5 col-xs-12 col-sm-12 col-form-label">
						<input className="form-check-input" disabled={this.props.base.globalProcessing ? true : false} type="radio" value={0} checked={this.state.selected === 0} onChange={this.switchTab} />
						<span className="form-check-label">{i18next.t("createDSSign")}</span>
					</label>
					<label className="col-lg-5 col-md-5 col-xs-12 col-sm-12 col-form-label">
						<input className="form-check-input" disabled={this.props.base.globalProcessing ? true : false} type="radio" value={1} checked={this.state.selected === 1} onChange={this.switchTab} />
						<span className="form-check-label">{i18next.t("verifyDSSign")}</span>
					</label>
				</div>
				{
					this.state.selected === 0
					? <CreateContainer />
					: <VerifyContainer />
				}
				{
					this.props.base.showErrorPopup
					? <ErrorPopup />
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);